{{ storefrontId }}
<div [class.override]="storefrontId === 572">
  <h2>{{ 'LOGIN.signInToYourAccount' | translate }}</h2>
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <div class="login-form">
      <app-input
        name="Email"
        type="email"
        [control]="loginForm.controls.email"
        label="{{ 'COMMON.emailAddress' | translate }}"
      ></app-input>
      @if (loginForm.controls.email.hasError('invalidDomain')) {
        <small class="p-error">
          {{ 'LOGIN.invalidDomainMessage' | translate }}
        </small>
      }
      <app-input
        name="Password"
        type="password"
        [control]="loginForm.controls.password"
        label="{{ 'COMMON.password' | translate }}"
      ></app-input>
      <div class="forgot-password">
        <a
          href=""
          routerLink="/reset-password"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
        >
          {{ 'LOGIN.forgotPassword' | translate | uppercase }}
        </a>
        <a
          href=""
          routerLink="/register"
          routerLinkActive="active"
          ariaCurrentWhenActive="page"
          queryParamsHandling="preserve"
        >
          {{ 'LOGIN.dontHaveAccount' | translate | uppercase }}
        </a>
      </div>
      <div class="login">
        <app-button
          label="{{ 'LOGIN.signIn' | translate }}"
          type="submit"
          [style]="{ width: '100%' }"
          [disabled]="loginForm.invalid"
          [loading]="loading"
          [fullWidth]="true"
        />
      </div>
      @if (ssoEnabled) {
        <div class="or-login-with">
          <span>Or login with</span>
        </div>
        @if (ssoProvider === 'microsoft') {
          <div class="microsoft-entra-login">
            <button
              type="button"
              (click)="onMicrosoftEntraLogin()"
              class="microsoft-entra-login-btn"
            >
              <img
                src="assets/img/icons/microsoft.svg"
                alt="Microsoft icon"
                class="microsoft-icon"
              />
              Microsoft
            </button>
          </div>
        }
        @if (ssoProvider === 'okta') {
          <div class="sso-login">
            <button type="button" (click)="onOktaLogin()" class="sso-login-btn">
              <img src="assets/img/icons/okta.svg" alt="Okta icon" class="sso-icon" />
              Okta
            </button>
          </div>
        }
      }
    </div>
  </form>
</div>
